const initState = {
    ui_loader:false,
    error:'',
    success_message:'',
    error_message:'',
  };
  const uiReducers = (state = initState, action) => {
    switch (action.type) {
        case "LOADING_UI":
            return { ...state,ui_loader:true};
        case "UNLOADING_UI":
            return { ...state,ui_loader:false};
        case "UNLOADING_UI":
            return { ...state,error:action.payload};
        case 'SUCCESS_DATA':
            return {...state,success_message:action.payload}
        case 'ERROR_DATA':
            return {...state,error_message:action.payload}
        default:
            return state;
    }
  };
  export default uiReducers;
  